var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',{attrs:{"id":"pie"}},[_c('PieChart',{attrs:{"data":_vm.pieDataReceivers}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }